export enum OrderStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  NETSUITE_FAILED = 'NETSUITE_FAILED',
  OFFLINE_PAYMENT = 'OFFLINE_PAYMENT'
}

export type StatusColor = 'success' | 'warning' | 'error' | 'info' | 'default'

export const ORDER_STATUS_COLORS: Record<OrderStatus, StatusColor> = {
  [OrderStatus.AWAITING_PAYMENT]: 'warning',
  [OrderStatus.PAID]: 'success',
  [OrderStatus.PAYMENT_FAILED]: 'error',
  [OrderStatus.NETSUITE_FAILED]: 'error',
  [OrderStatus.OFFLINE_PAYMENT]: 'success'
}

export const getOrderStatusColor = (status: string): StatusColor => {
  return ORDER_STATUS_COLORS[status as OrderStatus] || 'default'
}
